// Mock data for Silk and Sentiments - Luxury Indian Couture

export const heroData = {
  title: "Silk & Sentiment",
  subtitle: "Elegance in every thread",
  ctaText: "Explore the Archives",
  heroImage: "https://customer-assets.emergentagent.com/job_568566e0-ffb3-4a84-a1fa-2157a3f7e73e/artifacts/o01249hr_765D7045-41FA-4965-8076-193AD168A5CB.png"
};

export const craftsmanshipSections = [
  {
    id: 1,
    title: "The Zardozi Gold",
    subtitle: "Real Gold Embroidery",
    description: "Threads of pure silver and gold, meticulously hand-embroidered by master artisans. Each stitch carries centuries of heritage, transforming fabric into wearable art.",
    image: "https://images.unsplash.com/photo-1652722426884-647880c63bf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjBlbWJyb2lkZXJ5fGVufDB8fHx8MTc3MDA1ODE3Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "The Shadow of Lucknow",
    subtitle: "32 Stitches of Chikankari",
    description: "Chikankari — the poetry of white on white. Delicate shadow work that whispers elegance, born in the royal courts of Awadh and perfected over generations.",
    image: "https://images.unsplash.com/photo-1695668148100-987abc5841ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxJbmRpYW4lMjBlbWJyb2lkZXJ5fGVufDB8fHx8MTc3MDA1ODE3Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "The Artisan's Hand",
    subtitle: "Masters of the Craft",
    description: "Every creation is a collaboration with karigars whose families have practiced this craft for centuries. Their hands know the language of thread, their eyes see patterns in dreams.",
    image: "https://images.unsplash.com/photo-1631869382470-cd1722baebc7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhcnRpc2FuJTIwaGFuZHN8ZW58MHx8fHwxNzcwMDU4MTg0fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const collectionPieces = [
  {
    id: 1,
    name: "Lal Gulposh",
    description: "A crimson silk gharara set, hand-embroidered with gold zardozi stars and an ivory brocade kali panel.",
    technique: "Zardozi, Dabka & Aari",
    hours: 320,
    material: "Pure Silk & Tissue",
    image: "https://customer-assets.emergentagent.com/job_568566e0-ffb3-4a84-a1fa-2157a3f7e73e/artifacts/52xtxppp_IMG_3217.jpeg"
  },
  {
    id: 2,
    name: "Gulbadan",
    description: "Rose-gold zardozi lehenga with vintage gota patti.",
    technique: "Zardozi & Gota Patti",
    hours: 320,
    material: "Heritage Silk Brocade",
    image: "https://images.unsplash.com/photo-1724856605022-106d6dd6e842?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MjI5Nzl8MHwxfHNlYXJjaHw0fHxsZWhlbmdhfGVufDB8fHx8MTc3MDA1ODIwMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Begum Shahi",
    description: "Crimson velvet anarkali with aari embroidery inspired by Mughal miniatures.",
    technique: "Aari & Resham",
    hours: 280,
    material: "Italian Velvet",
    image: "https://images.unsplash.com/photo-1668371679302-a8ec781e876e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MjI5Nzl8MHwxfHNlYXJjaHwxfHxsZWhlbmdhfGVufDB8fHx8MTc3MDA1ODIwMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Mehrunissa",
    description: "Ivory silk dupatta with jaali work and baroque pearls.",
    technique: "Jaali & Pearl Embellishment",
    hours: 180,
    material: "Banarasi Silk",
    image: "https://images.unsplash.com/photo-1769706039344-7ad8d7ec2442?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0ODcwNjB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBJbmRpYW4lMjBicmlkYWx8ZW58MHx8fHwxNzcwMDU4MTkyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Afshan Jahan",
    description: "Antique gold tissue gharara with zari borders and vintage motifs.",
    technique: "Zari & Tissue Weaving",
    hours: 300,
    material: "Gold Tissue & Silk",
    image: "https://images.unsplash.com/photo-1769500804089-b91e952710a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0ODcwNjB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBJbmRpYW4lMjBicmlkYWx8ZW58MHx8fHwxNzcwMDU4MTkyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    name: "Raushan Ara",
    description: "Emerald silk lehenga with gold nakshi work and vintage sequins.",
    technique: "Nakshi & Sequin Work",
    hours: 260,
    material: "Raw Silk",
    image: "https://images.unsplash.com/photo-1746372283841-dbb3838f9935?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MjI5Nzl8MHwxfHNlYXJjaHwyfHxsZWhlbmdhfGVufDB8fHx8MTc3MDA1ODIwMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    name: "Zeb-un-Nisa",
    description: "Blush silk choli with mirror work and vintage rose motifs.",
    technique: "Mirror Work & Aari",
    hours: 200,
    material: "Pure Silk",
    image: "https://images.unsplash.com/photo-1760613130027-3959a3eb939c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0ODcwNjB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBJbmRpYW4lMjBicmlkYWx8ZW58MHx8fHwxNzcwMDU4MTkyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    name: "Jahanara",
    description: "Saffron silk saree with gota kinari and heritage brocade border.",
    technique: "Gota Kinari & Brocade",
    hours: 220,
    material: "Silk & Brocade",
    image: "https://images.unsplash.com/photo-1619043518800-7f14be467dca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxzaWxrJTIwZmFicmljfGVufDB8fHx8MTc3MDA1ODE2M3ww&ixlib=rb-4.1.0&q=85"
  }
];

export const bespokeJourney = [
  {
    step: 1,
    title: "Inquiry",
    description: "Chat with us on WhatsApp",
    icon: "message"
  },
  {
    step: 2,
    title: "Consultation",
    description: "Fabric & Design Selection",
    icon: "fabric"
  },
  {
    step: 3,
    title: "The Adda",
    description: "Work-in-Progress Updates",
    icon: "craft"
  },
  {
    step: 4,
    title: "Heritage Delivery",
    description: "Worldwide Shipping",
    icon: "delivery"
  }
];

export const whatsappConfig = {
  number: "919151060995",
  message: "Adaab. I wish to inquire about a bespoke Silk & Sentiment creation. Please guide me through the heritage archives."
};

export const readyToBuyPieces = [
  {
    id: 'rtb-1',
    name: "Qamar Blouse",
    description: "Handcrafted maroon silk blouse with heritage zari borders, ready to wear.",
    technique: "Zari & Dabka",
    price: 18500,
    material: "Pure Silk",
    image: "https://images.unsplash.com/photo-1756483488645-5973a1a92e33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBjb3V0dXJlJTIwYmxvdXNlJTIwc2lsayUyMGVtYnJvaWRlcmVkfGVufDB8fHx8MTc3NjcwMTIzNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 'rtb-2',
    name: "Firoza Jacket Blouse",
    description: "Turquoise raw silk jacket-blouse with fine zardozi floral motifs.",
    technique: "Zardozi Work",
    price: 22000,
    material: "Raw Silk",
    image: "https://images.unsplash.com/photo-1654758790049-8ad380620acc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjb3V0dXJlJTIwYmxvdXNlJTIwc2lsayUyMGVtYnJvaWRlcmVkfGVufDB8fHx8MTc3NjcwMTIzNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 'rtb-3',
    name: "Neelam Velvet Blouse",
    description: "Midnight navy velvet blouse with kamdani crescent embroidery.",
    technique: "Kamdani & Mukaish",
    price: 19800,
    material: "Velvet",
    image: "https://images.unsplash.com/photo-1654758782849-0a2be98c058f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBjb3V0dXJlJTIwYmxvdXNlJTIwc2lsayUyMGVtYnJvaWRlcmVkfGVufDB8fHx8MTc3NjcwMTIzNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 'rtb-4',
    name: "Zarina Kurta Set",
    description: "Saffron silk kurta with aari embroidery, paired with embellished dupatta.",
    technique: "Aari & Fine Thread",
    price: 26500,
    material: "Pure Silk",
    image: "https://images.unsplash.com/photo-1633329712176-6bd3dc5bf7d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjb3V0dXJlJTIwYmxvdXNlJTIwc2lsayUyMGVtYnJvaWRlcmVkfGVufDB8fHx8MTc3NjcwMTIzNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 'rtb-5',
    name: "Aasmaan Dupatta",
    description: "Sky blue organza dupatta with delicate naqshi hand-embroidery.",
    technique: "Naqshi Work",
    price: 14500,
    material: "Organza",
    image: "https://images.unsplash.com/photo-1739005191373-c47e73a38f6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBkdXBhdHRhJTIwc2FyZWUlMjByZWFkeSUyMHRvJTIwd2VhcnxlbnwwfHx8fDE3NzY3MDEyMzZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 'rtb-6',
    name: "Mahvash Lehenga",
    description: "Teal tissue lehenga with gold zari border and embellished dupatta.",
    technique: "Tissue Weaving & Zari",
    price: 48500,
    material: "Tissue & Silk",
    image: "https://images.unsplash.com/photo-1654436200209-de489ed205df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBkdXBhdHRhJTIwc2FyZWUlMjByZWFkeSUyMHRvJTIwd2VhcnxlbnwwfHx8fDE3NzY3MDEyMzZ8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const signatureFabrics = [
  "Pure Silk",
  "Uppada Silk",
  "Raw Silk",
  "Semi-Silk",
  "Crepe",
  "Organza",
  "Satin",
  "Tissue",
  "Velvet"
];

export const embroideryExpertise = [
  "Aari",
  "Zardozi Work",
  "Dabka",
  "Naqshi",
  "Kamdani",
  "Fine Thread Embroidery"
];

export const essencePoints = [
  "Meticulously handcrafted by skilled artisans",
  "Rooted in tradition, elevated with contemporary elegance",
  "Designed to reflect individuality, grace, and refined luxury",
  "Every piece is thoughtfully created, keeping your personal style at the heart of our process"
];
